module.exports = __webpack_public_path__ + "static/media/yieldify_logo_white.2e1cef4e.png";